import { PageTypeSuffix } from '@/constants'
import type { Post } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'

interface BlogCardType {
  post: Post
  featurePost?: Post[]
  imageWidth?: number
  imageHeight?: number
  type?: number
}

export const BlogCard = ({
  post,
  featurePost,
  imageWidth = 400,
  imageHeight = 226,
  type,
}: BlogCardType) => {
  return (
    <div
      className={`w-full cursor-pointer ${
        type === 3 ? 'flex items-center gap-x-2' : 'items-center'
      }`}
    >
      <Link
        href={`/${getTranslate(post.slugs.value)}${post.slugs.postfix}${
          PageTypeSuffix.POST
        }`}
        className={`relative ${
          type === 3
            ? 'h-[70px] max-w-[70px] flex-[0_0_70px] overflow-hidden rounded-lg'
            : 'mb-2 block overflow-hidden rounded-lg pt-[56.25%]'
        } ${type === 1 || type === 6 ? '!mb-2' : ''}`}
      >
        <ImageOptimize
          width={imageWidth}
          height={imageHeight}
          className={`${
            type === 3
              ? 'h-full w-full object-cover'
              : 'absolute left-0 top-0 block h-full w-full object-cover'
          }`}
          alt={getTranslate(post?.title) || ''}
          src={post?.images[0]}
          thumbnail
        />
        {type === 4 && (
          <div className='bg-black/70 absolute bottom-0 left-0 w-full p-1 text-white'>
            <h2 className='text-sm'>{getTranslate(post?.title)}</h2>
          </div>
        )}
      </Link>

      <div className={`relative ${type === 3 ? 'flex-auto' : ''}`}>
        <Link
          href={`/${getTranslate(post.slugs.value)}${post.slugs.postfix}${
            PageTypeSuffix.POST
          }`}
          className={`flex flex-col flex-wrap`}
        >
          {!featurePost && type !== 4 && (
            <h2
              className={`mb-1 line-clamp-2 overflow-hidden text-sm leading-tight ${
                type === 5 ? 'text-white' : 'text-sub'
              }`}
            >
              {getTranslate(post?.title)}
            </h2>
          )}

          {featurePost && (
            <>
              <h3 className='mb-1 text-xl leading-tight text-sub'>
                {getTranslate(post?.title)}{' '}
              </h3>
              <span className='mb-1 text-sm leading-tight text-sub'>
                {getTranslate(post?.description)}
              </span>
            </>
          )}
          <p className='flex items-center gap-6 text-xs font-normal text-sub'></p>
        </Link>
      </div>
    </div>
  )
}

export default BlogCard
